<script setup lang="ts">
defineProps<{
  label: string;
  hint?: string;
  standalone?: boolean;
}>();
</script>

<template>
  <div
    class="z-20 flex justify-center"
    :class="
      standalone
        ? 'min-h-[360px] items-center bg-white'
        : 'absolute inset-0 items-start justify-center rounded-[18px] bg-white/[0.66] pt-6 backdrop-blur-[1px] sm:pt-7'
    "
    role="status"
    aria-live="polite"
  >
    <div
      class="flex min-w-[250px] max-w-[290px] flex-col items-center rounded-2xl border border-app-border/80 bg-white/95 px-7 py-6 text-center shadow-[0_14px_38px_rgba(17,30,25,0.13)]"
    >
      <span class="search-results-loader-ring" aria-hidden="true" />
      <span class="mt-4 text-sm font-bold text-primary">{{ label }}</span>
      <span v-if="hint" class="mt-1.5 text-xs font-medium text-app-muted">{{
        hint
      }}</span>
    </div>
  </div>
</template>

<style scoped>
.search-results-loader-ring {
  width: 42px;
  height: 42px;
  border-radius: 9999px;
  border: 3px solid rgba(19, 122, 104, 0.18);
  border-top-color: #137a68;
  border-right-color: rgba(19, 122, 104, 0.58);
  animation: senta-results-spin 0.78s linear infinite;
}

@keyframes senta-results-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .search-results-loader-ring {
    animation-duration: 1.8s;
  }
}
</style>
